import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SALES_ANALYTICS_API_URL } from '../sales-analytics-api.constants';
import { IFailedTransactionsApiService } from './failed-transactions-api.interface';
import { ExportExcelPdfService } from '../../../export-excel-pdf/export-excel-pdf.service';
import { HandleBlobHttpResponseOptions } from '@orderna/admin-panel/src/types/handle-blob-http-response-options';
import { SuccessResponse } from '../../../shared/success-response';
import { ExportFailedTransactionsQueryDto } from './dtos/export-failed-transactions.query.dto';
import { FindFailedTransactionsQueryDto } from './dtos/find-failed-transactions.query.dto';
import { FindFailedTransactionsResponseDto } from './dtos/find-failed-transactions.response.dto';

@Injectable({
  providedIn: 'root',
})
export class FailedTransactionsApiService
  implements IFailedTransactionsApiService
{
  private readonly ENDPOINT = 'failed-transactions';

  private http = inject(HttpClient);
  private exportService = inject(ExportExcelPdfService);

  async findFailedTransactions(
    query: FindFailedTransactionsQueryDto
  ): Promise<FindFailedTransactionsResponseDto> {
    const params = new HttpParams({ fromObject: query as any });

    const response = await firstValueFrom(
      this.http.get<SuccessResponse<FindFailedTransactionsResponseDto>>(
        `${SALES_ANALYTICS_API_URL}/${this.ENDPOINT}`,
        { params }
      )
    );

    return response.data;
  }

  exportFailedTransactions(
    query: ExportFailedTransactionsQueryDto,
    options?: HandleBlobHttpResponseOptions
  ) {
    const { print = false } = options ?? {};
    const params = new HttpParams({ fromObject: query as any });

    this.exportService.export({
      endpoint: this.ENDPOINT,
      params,
      print,
    });
  }
}
